import moment from 'moment';
import 'moment/locale/de';

export function dayOfYear(dateStr, year) {
  const date = moment(dateStr);
  const startOfYear = moment(`${year}-01-01`);
  return date.diff(startOfYear, 'days');
}

export function daysInYear(year) {
  return moment(`${year}-12-31`).dayOfYear();
}

export function groupConsecutiveDays(days, sortKey = 'date') {
  if (!days || days.length === 0) return [];

  const sorted = [...days].sort((a, b) =>
    moment(a[sortKey]).diff(moment(b[sortKey])),
  );

  const ranges = [];
  let currentRange = {
    startDate: sorted[0][sortKey],
    endDate: sorted[0][sortKey],
    days: [sorted[0]],
  };

  for (let i = 1; i < sorted.length; i++) {
    const prevDate = moment(sorted[i - 1][sortKey]);
    const currDate = moment(sorted[i][sortKey]);
    const diff = currDate.diff(prevDate, 'days');

    if (diff <= 3) {
      currentRange.endDate = sorted[i][sortKey];
      currentRange.days.push(sorted[i]);
    } else {
      ranges.push(currentRange);
      currentRange = {
        startDate: sorted[i][sortKey],
        endDate: sorted[i][sortKey],
        days: [sorted[i]],
      };
    }
  }
  ranges.push(currentRange);
  return ranges;
}

export function isWeekend(dateStr) {
  const day = moment(dateStr).day();
  return day === 0 || day === 6;
}

export function getMonthsOfYear(year, locale = 'de') {
  return Array.from({ length: 12 }, (_, i) => {
    const month = moment(`${year}-${String(i + 1).padStart(2, '0')}-01`).locale(locale);
    return {
      label: month.format('MMM'),
      startDay: dayOfYear(month.format('YYYY-MM-DD'), year),
      days: month.daysInMonth(),
    };
  });
}
